<template>
  <div class="wrapper">
    <div class="messageShow" v-show="isShow">
      <span>{{ showMessage }}</span>
    </div>
    <div id="map" ref="map"></div>
    <div class="content">
      <div class="module">
        <div class="right">
          <img src="../../assets/dianhua.png" alt="" @click="dadianhua"/>
          <p>通话</p>
          <img src="../../assets/liuyan.png" alt="" @click="liuyan"/>
          <p>留言</p>
          <img src="../../assets/guiji.png" alt="" @click="guiji"/>
          <p>轨迹</p>
          <img src="../../assets/daohang.png" alt="" @click="daohang"/>
          <p>导航</p>
          <img src="../../assets/shezhi.png" alt="" @click="setting"/>
          <p>设置</p>
        </div>
      </div>

      <!-- <div class="dingwei-left">
        <img src="../../assets/dingwei.png" alt="" @click="positionOntime()" />
      </div> -->
      <div class="dingwei-right">
        <img src="../../assets/big.png" alt="" @click="bigMap()"/>
        <img src="../../assets/small.png" alt="" @click="smallMap()"/>
      </div>

      <!-- <div class="dingwei">
        <div class="left">
          <img src="../../assets/dingwei.png" alt="" />
        </div>
        <div class="right">
          
        </div>
      </div> -->
      <div class="positionInfo">
        <p class="user">
          <span class="name">{{ data.studentName }}</span>
          <span class="online">{{
              data.position.onlineStatus == 1 ? "在线" : "离线"
            }}</span>
          <span class="position">
            <img
                src="../../assets/position.png"
                alt=""
                @click="reflushPosition()"
            />
        <p>刷新定位</p>
        </span>
        </p>
        <p class="common">
          <span>设备：{{ data.studentCard }}</span>
          <span class="batterylogo">
        <div class="logoconn"></div>
        </span>
        <span class="point"></span>
        <span>{{ data.battery }}</span>
        </p>
        <p class="common">
          <span>定位：{{ data.position.posTypeStr }}</span>
          <span>{{ data.dateTime }}</span>
        </p>
        <p class="common">
          <span class="weizhi">位置：{{ data.position.posStrData }}</span>
        </p>
      </div>
    </div>

    <el-dialog
        :visible.sync="phoneDialogVisible"
        width="5.4rem"
        :show-close="false"
        top="60%"
        custom-class="dialog-common"
        center
    >
      <p style="font-size: 0.28rem;padding-top:0.2rem">拨打电话</p>
      <p style="font-size: 0.4rem">{{ data.devicePhone }}</p>

      <div class="footer">
        <p class="cancel" @click="cancelPhoneDialog()">取消</p>
        <a :href="telPhone"><p class="call">呼叫</p></a>
        <div class="clear"></div>
      </div>
    </el-dialog>

    <el-dialog
        :visible.sync="setDialogVisible"
        width="5.8rem"
        :show-close="false"
        top="60%"
        custom-class="dialog-set-common"
        center
    >
      <div class="setContent">
        <div class="left">
          <img
              src="../../assets/qinqinghaoma.png"
              alt=""
              @click="clickQinqinghaoma"
          />
          <p>亲情号码</p>
          <img
              src="../../assets/dingweimoshi.png"
              alt=""
              @click="positionModel"
          />
          <p>定位模式</p>
        </div>
        <div class="middle">
          <img
              src="../../assets/dianziweilan.png"
              alt=""
              @click="dianziweilan"
          />
          <p>电子围栏</p>
          <img
              src="../../assets/yuanchengkongzhi.png"
              alt=""
              @click="remoteControl()"
          />
          <p>远程控制</p>
        </div>
        <div class="right">
          <img
              src="../../assets/tonghuaqingdan.png"
              alt=""
              @click="tonghuaqingdan"
          />
          <p>通话清单</p>
        </div>
        <div class="clear"></div>
      </div>
      <div style="text-align: center">
        <img
            src="../../assets/cancelCard.png"
            style="width: 30px; margin-top: 1.3rem"
            alt=""
            @click="cancelSetting()"
        />
      </div>
    </el-dialog>
    <el-dialog
        :visible.sync="showPositionDialogVisible"
        width="5.4rem"
        :show-close="false"
        top="60%"
        title="定位模式"
        custom-class="position-dialog-common"
        center
    >
      <div class="position-item" @click="changeItem('1')">
        <span>耗电</span>
        <el-radio v-model="item" label="1">耗电</el-radio>
      </div>
      <div class="position-item" @click="changeItem('0')">
        <span>正常</span>
        <el-radio v-model="item" label="0">正常</el-radio>
      </div>

      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="showPositionDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="setLocationModelData()"
          >确 定</el-button
        >
      </span> -->
      <div class="footer">
        <p class="cancel" @click="showPositionDialogVisible = false">取 消</p>
        <a @click="setLocationModelData()"><p class="call">确 定</p></a>
        <div class="clear"></div>
      </div>
    </el-dialog>

    <el-dialog
        :visible.sync="remoteControlDialogVisible"
        width="5.4rem"
        :show-close="false"
        top="60%"
        title="远程控制"
        custom-class="position-dialog-common"
        center
    >
      <div class="position-item" @click="remoteControlData(3)">
        <span>重启</span>
        <img
            src="../../assets/jiazai.png"
            alt=""

        />
      </div>
      <div class="position-item" @click="remoteControlData(2)">
        <span>关机</span>
        <img
            src="../../assets/guanji.png"
            alt=""

        />
      </div>

      <div class="cancelRemote" @click="remoteControlDialogVisible = false">
        取消
      </div>
    </el-dialog>

    <el-dialog
        :visible.sync="daohangDialogVisible"
        :show-close="false"
        custom-class="daohang-dialog-common"
        :before-close="handleDaohangClose"
        :close-on-click-modal="false"
        center
    >
      <div class="addContent">
        <div class="yuanxing" @click="searchMap('gd')">高德地图</div>
        <div class="duobianxing" @click="searchMap('bd')">百度地图</div>

        <div class="cancel" @click="handleDaohangClose()">取消</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  showStudentInfoInH5,
  setLocationModel,
  remoteControl,
} from "@/api/studentCard.js";

export default {
  data() {
    return {
      accessToken: "",
      studentId: "",
      imei: "",
      map: "",
      studentName: "",
      viaMarker: "",
      icon: "",
      phoneDialogVisible: false,
      setDialogVisible: false,
      showPositionDialogVisible: false,
      remoteControlDialogVisible: false,
      daohangDialogVisible: false,
      telPhone: "tel:13262835750",
      center: [120.716586, 31.322227],
      data: {
        position: {
          lon: "",
          lat: "",
          status: "",
          posStrData: "暂无位置数据",
          posTypeStr: "暂无定位方式",
          onlineStatus: 0,
        },
        battery: 0,
        studentCard: "",
        studentName: "",
        studentId: "",
        studentPic: "",
        devicePhone: "",
        dateTime: "2022-01-01 00:00:00",
      },
      zoom: 15,
      item: "0",
      isShow: false,
      showMessage: "",
      partnerAddress: "",
      lng: "",
      lat: "",
      bdLng: "",
      bdLat: "",
    };
  },
  mounted() {
    this.initParam();
    this.getData();
    this.getMap();
  },
  methods: {
    bigMap() {
      console.log(this.map);
      if (this.zoom <= 18) {
        this.zoom = this.zoom + 1;
        this.map.setZoom(this.zoom);
      }
    },
    smallMap() {
      if (this.zoom >= 5) {
        this.zoom = this.zoom - 1;
        this.map.setZoom(this.zoom);
      }
    },
    reflushPosition() {
      this.isShow = true;
      this.showMessage = "已刷新";
      setTimeout(() => {
        this.showMessage = "";
        this.isShow = false;
      }, 3000);
      this.getData();
    },
    initParam() {
      let urlParam = this.$route.query;
      if (urlParam.accesstoken) {
        this.accessToken = urlParam.accesstoken
      } else {
        this.accessToken = urlParam.accessToken
      }
      this.studentId = urlParam.studentId;
      this.imei = urlParam.imei;
      console.log(this.accessToken + ":" + this.studentId + ":" + this.imei);
    },
    getData() {
      let params = {
        Authorization: this.accessToken,
        studentId: this.studentId,
        type: 11,
      };
      showStudentInfoInH5(params).then((res) => {
        if (res.status == 200) {
          if (!res.content.hasOwnProperty("position")) {
            this.data.studentCard = res.content.studentCard;
            this.data.studentName = res.content.studentName;
            this.data.studentId = res.content.studentId;
            this.data.studentPic = res.content.studentPic;
            this.data.devicePhone = res.content.devicePhone;
            this.data.battery =
                res.content.battery == null ? 0 : res.content.battery;
          } else {
            this.data = res.content;
          }
          this.studentName = res.content.studentName;
          this.item = res.content.mode == null ? "0" : String(res.content.mode);
          var logoconn = document.getElementsByClassName("logoconn");
          var battery = res.content.battery.substring(
              0,
              res.content.battery.length - 1
          );
          var num = (20.16 * Number(battery)) / 100;
          // console.log(logoconn[0])
          logoconn[0].setAttribute("style", "width:" + num.toFixed(2) + "px");

          this.lat = res.content.hasOwnProperty("position")
              ? res.content.position.lat
              : "31.322227";
          this.lng = res.content.hasOwnProperty("position")
              ? res.content.position.lon
              : "120.716586";
          this.bdLat = res.content.hasOwnProperty("position")
              ? res.content.position.bdLat
              : "31.322227";
          this.bdLng = res.content.hasOwnProperty("position")
              ? res.content.position.bdLon
              : "120.716586";
          this.partnerAddress = res.content.hasOwnProperty("position")
              ? res.content.position.posStrData
              : "暂无定位数据";

          console.log(this.lng, this.lat);
          this.center = new AMap.LngLat(this.lng, this.lat);
          var that = this;
          that.map.setCenter(that.center);
          that.viaMarker.setPosition(that.center);

          var iconNew = new AMap.Icon({
            size: new AMap.Size(40, 40), // 图标尺寸
            image: that.data.studentPic,
            // image:"https://zhongqiyun-static-1307006238.cos.ap-shanghai.myqcloud.com/childImage4.png",
            imageSize: new AMap.Size(26, 26), // 根据所设置的大小拉伸或压缩图片
          });
          that.viaMarker.setIcon(iconNew);

          this.telPhone = "tel:" + res.content.devicePhone;
        }
      });
    },
    getMap() {
      //创建地图
      this.map = new AMap.Map("map", {
        //mapStyle: 'amap://styles/grey',
        center: this.center,
        enableHighAccuracy: true, //是否使用高精度定位，默认:true
        zoomToAccuracy: true,
        zoom: this.zoom,
        scrollWheel: false,
        dragEnable: true, //是否可拖动
        resizeEnable: true,
        rotateEnable: false,
      });

      this.icon = new AMap.Icon({
        size: new AMap.Size(0, 0), // 图标尺寸
        image:
            "https://zhongqiyun-static-1307006238.cos.ap-shanghai.myqcloud.com/childImage4.png", // Icon的图像
        // imageOffset: new AMap.Pixel(0, -60), // 图像相对展示区域的偏移量，适于雪碧图等
        imageSize: new AMap.Size(20, 20), // 根据所设置的大小拉伸或压缩图片
      });

      this.viaMarker = new AMap.Marker({
        position: this.center,
        // 将一张图片的地址设置为 icon
        icon: this.icon,
        // icon:this.data.studentPic,
        // 设置了 icon 以后，设置 icon 的偏移量，以 icon 的 [center bottom] 为原点
        offset: new AMap.Pixel(-13, -30),
      });
      this.viaMarker.setMap(this.map);

    },

    showInfoClick(e) {
      this.map.clearMap(); //清理地图
      let lng = e.lnglat.getLng(); //获取经度
      let lat = e.lnglat.getLat(); //获取纬度

      console.log(e, lng, lat);

      this.regeocoder([lng, lat]);
      //marker点
      let marker = new AMap.Marker({
        position: [lng, lat],
        offset: new AMap.Pixel(-13, -30),
      });
      this.map.add(marker); //加载点
      this.map.setFitView(); //缩放至地图
      this.lnglat = lng + "," + lat; //将经纬度绑定至input输入框
    },
    remoteControlData(controlType) {
      let params = {
        Authorization: this.accessToken,
        card: this.imei,
        controlType: controlType,
        type: 11,
      };
      remoteControl(params).then((res) => {
        if (res.status == 200) {
          this.remoteControlDialogVisible = false;
          this.isShow = true;
          if (3 == controlType) {
            this.showMessage = "学生证已远程重启";
          } else if (2 == controlType) {
            this.showMessage = "学生证已远程关机！";
          }
          setTimeout(() => {
            this.isShow = false;
            this.showMessage = "";
          }, 3000);
        } else {
          this.isShow = true;
          this.showMessage = res.errorMs;
          setTimeout(() => {
            this.isShow = false;
            this.showMessage = "";
          }, 3000);
        }
      });
    },
    setLocationModelData() {
      let params = {
        Authorization: this.accessToken,
        card: this.imei,
        model: this.item,
        type: 11,
      };
      setLocationModel(params).then((res) => {
        if (res.status == 200) {
          this.showPositionDialogVisible = false;
          this.isShow = true;
          this.showMessage = "操作成功";
          setTimeout(() => {
            this.isShow = false;
            this.showMessage = "";
          }, 3000);
        } else {
          this.isShow = true;
          this.showMessage = res.errorMs;
          setTimeout(() => {
            this.isShow = false;
            this.showMessage = "";
          }, 3000);
        }
      });
    },
    dadianhua() {
      this.phoneDialogVisible = true;
    },

    liuyan() {
      this.$router.push({
        path:
            "/studentCard/liuyan?accessToken=" +
            this.accessToken +
            "&studentId=" +
            this.studentId +
            "&imei=" +
            this.imei,
      });
    },

    guiji() {
      this.$router.push({
        path:
            "/studentCard/guiji?accessToken=" +
            this.accessToken +
            "&studentId=" +
            this.studentId +
            "&imei=" +
            this.imei +
            "&pic=" +
            this.data.studentPic,
      });
    },

    searchMap(signMap) {
      let self = this;
      // var loadDateTime = new Date();

      const t = 1000;
      const t1 = Date.now();
      const ifr = document.createElement("iframe");
      if (self.partnerAddress && self.partnerAddress != "") {
        //景点位置partnerAddress 景点经纬度lng lat
        var lng = self.lng;
        var lat = self.lat;
        var bdlng = self.bdLng;
        var bdlat = self.bdLat;
        console.log(bdlng);
        console.log(bdlat);
        if (signMap == "gd") {
          // 高德地图
          if (self.customBrowserVersion().android) {
            var url =
                "androidamap://viewMap?sourceApplication=中企云-JS-API&poiname=" +
                self.partnerAddress +
                "&lat=" +
                lat +
                "&lon=" +
                lng +
                "&dev=0";
            ifr.setAttribute("src", url);
            ifr.setAttribute("style", "display:none");
            document.body.appendChild(ifr);
            // window.location.href =url

            //判断是否跳转
            setTimeout(function () {
              // 启动app时间较长处理
              const t2 = Date.now();
              document.body.removeChild(ifr);
              if (t2 - t1 < t + 100) {
                console.log("hasApp", false);
                // 没有安装App，跳转到对应的App下载页面。
                // 下面的例子App下载页面也是H5页面。
                window.location.href =
                    "https://uri.amap.com/marker?position=" +
                    lng +
                    "," +
                    lat +
                    "&name=" +
                    self.partnerAddress; // alert("1234")
              } else {
                console.log("hasApp", true);
                // 已经安装App，下面的this.url是需要跳转到app的schema链接。
                window.location.href = url;
              }
            }, t);
          } else if (self.customBrowserVersion().ios) {
            var gdIOSurl =
                "iosamap://viewMap?sourceApplication=中企云-JS-API&poiname=" +
                self.partnerAddress +
                "&lat=" +
                lat +
                "&lon=" +
                lng +
                "&dev=0";
            ifr.setAttribute("src", gdIOSurl);
            ifr.setAttribute("style", "display:none");
            document.body.appendChild(ifr);
            // window.location.href =url

            //判断是否跳转
            setTimeout(function () {
              // 启动app时间较长处理
              const t2 = Date.now();
              document.body.removeChild(ifr);
              if (t2 - t1 < t + 100) {
                console.log("hasApp", false);
                // 没有安装App，跳转到对应的App下载页面。
                // 下面的例子App下载页面也是H5页面。
                window.location.href =
                    "https://uri.amap.com/marker?position=" +
                    lng +
                    "," +
                    lat +
                    "&name=" +
                    self.partnerAddress; // alert("1234")
              } else {
                console.log("hasApp", true);
                // 已经安装App，下面的this.url是需要跳转到app的schema链接。
                window.location.href = gdIOSurl;
              }
            }, t);
          }
        } else if (signMap == "bd") {
          // 百度地图
          if (self.customBrowserVersion().android) {
            var bdAndrurl =
                "bdapp://map/direction?destination=" +
                bdlat +
                "," +
                bdlng +
                "&region=" +
                self.partnerAddress +
                "&coord_type=bd09ll&mode=driving&src=com.zqy.webjs";
            ifr.setAttribute("src", bdAndrurl);
            ifr.setAttribute("style", "display:none");
            document.body.appendChild(ifr);
            // window.location.href =url

            //判断是否跳转
            setTimeout(function () {
              // 启动app时间较长处理
              const t2 = Date.now();
              document.body.removeChild(ifr);
              if (t2 - t1 < t + 100) {
                console.log("hasApp", false);
                // 没有安装App，跳转到对应的App下载页面。
                // 下面的例子App下载页面也是H5页面。
                window.location.href =
                    "http://api.map.baidu.com/marker?location=" +
                    bdlat +
                    "," +
                    bdlng +
                    "&title=" +
                    self.partnerAddress +
                    "&content=" +
                    self.partnerAddress +
                    "&output=html&src=com.zqy.webjs";
              } else {
                console.log("hasApp", true);
                // 已经安装App，下面的this.url是需要跳转到app的schema链接。
                window.location.href = bdAndrurl;
              }
            }, t);
          }
          if (self.customBrowserVersion().ios) {
            var bdIOSurl =
                "baidumap://map/direction?destination=" +
                bdlat +
                "," +
                bdlng +
                "&region=" +
                self.partnerAddress +
                "&coord_type=bd09ll&mode=driving";
            ifr.setAttribute("src", bdIOSurl);
            ifr.setAttribute("style", "display:none");
            document.body.appendChild(ifr);
            // window.location.href =url

            //判断是否跳转
            setTimeout(function () {
              // 启动app时间较长处理
              const t2 = Date.now();
              document.body.removeChild(ifr);
              if (t2 - t1 < t + 100) {
                console.log("hasApp", false);
                // 没有安装App，跳转到对应的App下载页面。
                // 下面的例子App下载页面也是H5页面。
                window.location.href =
                    "http://api.map.baidu.com/marker?location=" +
                    bdlat +
                    "," +
                    bdlng +
                    "&title=" +
                    self.partnerAddress +
                    "&content=" +
                    self.partnerAddress +
                    "&output=html&src=com.zqy.webjs";
              } else {
                console.log("hasApp", true);
                // 已经安装App，下面的this.url是需要跳转到app的schema链接。
                window.location.href = bdIOSurl;
              }
            }, t);
          }
        }
      } else {
        this.$toast.showToast("暂不支持");
      }
    },

    daohang() {
      this.daohangDialogVisible = true;
    },

    //区分设备
    customBrowserVersion() {
      var u = navigator.userAgent;
      return {
        trident: u.indexOf("Trident") > -1, //IE内核
        presto: u.indexOf("Presto") > -1, //opera内核
        webKit: u.indexOf("AppleWebKit") > -1, //苹果、谷歌内核
        gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1, //火狐内核
        mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
        android: u.indexOf("Android") > -1 || u.indexOf("Adr") > -1, //android终端
        iPhone: u.indexOf("iPhone") > -1, //是否为iPhone或者QQHD浏览器
        iPad: u.indexOf("iPad") > -1, //是否iPad
        webApp: u.indexOf("Safari") == -1, //是否web应用程序，没有头部与底部
        weixin: u.indexOf("MicroMessenger") > -1, //是否微信 （2015-01-22新增）
        qq: u.match(/\sQQ/i) == " qq", //是否QQ
        isBaidu: u.indexOf("baiduboxapp") !== -1, //是否为百度浏览器
        isqqBrowser: u.indexOf("mqqbrowser") !== -1, //是否为qq浏览器
        isWxBrowser: u.indexOf("micromessenger") !== -1, //是否为微信浏览器
        isUc: u.indexOf("ucbrowser") !== -1, //是否为uc浏览器
      };
    },

    setting() {
      this.setDialogVisible = true;
    },

    cancelSetting() {
      this.setDialogVisible = false;
    },

    cancelPhoneDialog() {
      this.phoneDialogVisible = false;
    },

    positionOntime() {
    },

    positionModel() {
      this.setDialogVisible = false;
      this.showPositionDialogVisible = true;
    },

    remoteControl() {
      this.setDialogVisible = false;
      this.remoteControlDialogVisible = true;
    },

    // 通过经纬度获取地址
    regeocoder(loc) {
      //逆地理编码
      console.log(loc);
      var that = this;
      var geocoder = new AMap.Geocoder({
        radius: 1000,
        extensions: "all",
      });
      geocoder.getAddress(loc, function (status, result) {
        if (status === "complete" && result.info === "OK") {
          console.log(result);

          var address = result.regeocode.formattedAddress; //返回地址描述
          that.address = address;
          that.currentLonLat = [...loc, address];
          console.log(that.currentLonLat);
        }
      });
    },
    clickQinqinghaoma() {
      this.$router.push({
        path:
            "/studentCard/qinqinghaoma?accessToken=" +
            this.accessToken +
            "&studentId=" +
            this.studentId +
            "&imei=" +
            this.imei,
      });
    },
    dianziweilan() {
      this.$router.push({
        path:
            "/studentCard/dianziweilan?accessToken=" +
            this.accessToken +
            "&studentId=" +
            this.studentId +
            "&imei=" +
            this.imei +
            "&center=" +
            this.center,
      });
    },
    tonghuaqingdan() {
      this.$router.push({
        path:
            "/studentCard/callList?accessToken=" +
            this.accessToken +
            "&studentId=" +
            this.studentId +
            "&imei=" +
            this.imei +
            "&studentName=" +
            this.studentName,
      });
    },
    // callPhone() {
    //   widnow.location.href = "tel:" + callPhoneNumer;
    // },

    handleDaohangClose() {
      this.daohangDialogVisible = false;
    },
    changeItem(value) {
      if ('1' == value) {
        this.item = '1'
      } else {
        this.item = '0'
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .amap-copyright {
  display: none !important;
}

/deep/ .amap-logo {
  display: none !important;
}

/deep/ .dialog-set-common {
  border-radius: 10px;
  height: 4.2rem;
}

/deep/ .amap-icon {
  background: url("../../assets/dingweiborder.png") center center no-repeat;
  background-size: 100%;
}

/deep/ .amap-icon img {
  border-radius: 50%;
  position: absolute;
  left: 50% !important;
  top: 40% !important;
  transform: translate(-50%, -50%);
}

.setContent {
  padding: 0 10px;

  .left {
    width: 32%;
    float: left;
    text-align: center;

    img {
      height: 0.9rem;
    }

    p {
      font-size: 0.26rem;
      margin-bottom: 8px;
    }
  }

  .middle {
    width: 32%;
    float: left;
    text-align: center;

    img {
      height: 0.9rem;
    }

    p {
      font-size: 0.26rem;
      margin-bottom: 8px;
    }
  }

  .right {
    width: 32%;
    float: left;
    text-align: center;

    img {
      height: 0.9rem;
    }

    p {
      font-size: 0.26rem;
      margin-bottom: 8px;
    }
  }

  .clear {
    content: "";
    display: block;
    clear: both;
  }
}

/deep/ .daohang-dialog-common {
  position: absolute;
  width: 100%;
  // border-radius: 10px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  height: 3.76rem;
  //   margin-top: 0rem;
  bottom: 0;
  margin-bottom: 0;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0.1rem 0 0.1rem !important;
  }
}

.addContent {
  background-color: #f5f5f5;
  font-family: #222222;
  font-size: 0.34rem;
  text-align: center;

  .yuanxing {
    height: 1.12rem;
    line-height: 1.12rem;
    background-color: #ffffff;
    border-bottom: 1px solid #e5e5e5;
  }

  .duobianxing {
    height: 1.12rem;
    line-height: 1.12rem;

    background-color: #ffffff;
    margin-bottom: 0.2rem;
  }

  .cancel {
    height: 1.12rem;

    background-color: #ffffff;
    line-height: 1.12rem;

    // vertical-align: middle;
  }
}

/deep/ .dialog-common {
  border-radius: 10px;
  height: 2.8rem;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    height: 100%;
  }

}

.position-item {
  height: 0.84rem;
  line-height: 0.84rem;
  border-bottom: 1px solid rgba(0, 0, 80, 0.02);

  span {
    margin-left: 0.2rem;
    font-size: 0.34rem;
    color: #000000;
  }

  img {
    display: table-cell;

    vertical-align: middle;
    float: right;
    // margin-right: 0.2rem;
    // line-height: 0.84rem;
    height: 0.48rem;
    margin: 0.2rem 0.2rem auto auto;
  }
}

.cancelRemote {
  height: 1.32rem;
  line-height: 1.32rem;
  text-align: center;
  border-top: 1px solid rgba(0, 0, 80, 0.02);
  font-size: 0.34rem;
  color: #333333;
}

/deep/ .position-dialog-common {
  border-radius: 10px;
  height: 4.08rem;
}

/deep/ .el-radio {
  float: right;
  margin-right: 0.2rem;
  line-height: 0.84rem;
}

/deep/ .el-radio__label {
  display: none;
}

/deep/ .dialog-common p {
  font-size: 0.4rem;
  text-align: center;
  font-family: "苹方-简 常规体";
  margin: 0 auto 0.30rem;
  color: #000000;
}

/deep/ .el-dialog--center .el-dialog__body {
  padding: 0;
}

/deep/ .footer {
  font-size: 0.34rem;
  width: 100%;
  bottom: 1px;
  height: 0.86rem;
  position: absolute;

  .cancel {
    padding: auto 50px 20px;
    color: #333333;
    float: left;
    width: 50%;
    text-align: center;
    line-height: 0.86rem;
    border-right: 1px solid #dbd6d6;
    border-top: 1px solid #dbd6d6;
  }

  .call {
    color: #2ad0b5;
    float: left;
    width: 50%;
    line-height: 0.86rem;

    text-align: center;
    border-top: 1px solid #dbd6d6;
  }

  .clear {
    content: "";
    display: block;
    clear: both;
  }
}

.wrapper {
  // background-color: #c6e926;
  width: 100%;
  position: absolute;
  top: 0rem;
  bottom: 0rem;

  .messageShow {
    height: 0.5rem;
    background-color: #000000;
    opacity: 0.6;
    color: #fff;
    width: fit-content;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    line-height: 0.5rem;
    z-index: 9999;
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    margin: auto;
    border-radius: 3px;

    span {
      margin: 8px;
    }
  }

  #map {
    height: 100%;
    width: 100%;
    position: relative;
  }

  .content {
    width: 94%;
    margin: 0 auto;
  }

  .module {
    width: 0.9rem;
    height: 5.96rem;
    position: fixed;
    bottom: 0.5rem;
    z-index: 999;
    margin-bottom: 5.18rem;
    right: 3%;

    .right {
      height: 5.96rem;
      width: 0.9rem;
      background-color: #ffffff;
      border-radius: 10px;
      float: right;
      z-index: 100;

      img {
        display: block;
        height: 0.44rem;
        margin: 0.2rem auto;
      }

      p {
        text-align: center;
        font-family: #222222;
        font-size: 0.22rem;
        margin: -0.1rem auto 0.28rem;
      }
    }
  }

  .dingwei-left {
    width: 0.9rem;
    height: 1.12rem;
    position: fixed;
    bottom: 0.3rem;
    z-index: 999;
    margin-bottom: 3.2rem;
    // margin: 10px auto ;
  }

  .dingwei-right {
    width: 0.9rem;
    height: 1.68rem;
    width: 0.9rem;
    position: fixed;
    bottom: 0.5rem;
    z-index: 999;
    margin-bottom: 3.2rem;
    right: 3%;
    background-color: #ffffff;
    border-radius: 10px;

    img {
      display: block;
      width: 0.32rem;
      margin: 0.3rem auto 0.5rem;
    }

    // margin: 10px auto ;
  }

  .positionInfo {
    width: 94%;
    height: 2.8rem;
    position: fixed;
    bottom: 0.5rem;
    z-index: 999;
    background-color: #ffffff;
    border-radius: 10px;
    margin: 10px auto;

    .user {
      margin-top: 15px;
      margin-left: 15px;
      height: 0.62rem;

      .name {
        font-family: "苹方-简 中黑体";
        font-size: 0.42rem;
        font-weight: bolder;
        height: 0.58rem;
      }

      .online {
        border: 0.02rem solid #ffa423;
        border-radius: 0.5rem;
        width: 0.76rem;
        height: 0.36rem;
        text-align: center;
        margin: -0.12rem 0.12rem 0.12rem;
        color: #ffa423;
        font-size: 0.22rem;
        padding: 0.05rem 0.16rem 0.06rem 0.16rem;
      }

      .position {
        float: right;
        margin-right: 15px;

        img {
          width: 0.6rem;
          height: 0.6rem;
          margin-top: -0.2rem;
        }

        p {
          font-family: "苹方-简 中黑体";
          font-size: 0.22rem;
          margin-left: -6px;
          color: #222222;
        }
      }
    }

    .common {
      margin-top: 9px;
      margin-left: 15px;
      font-size: 0.28rem;
      color: #666666;
      font-family: "苹方-简 常规体";

      span {
        margin-right: 10px;
      }

      .weizhi {
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 6.56rem;
      }

      .batterylogo {
        width: 24.64px;
        height: 12.69px;
        border: 0.5px solid #666666;
        display: inline-block;

        .logoconn {
          width: 20.16px;
          height: 8.51px;
          // padding: 0.04rem 0.06rem;
          background-color: #666666;
          margin: 1px auto auto 1px;
          line-height: 8.21px;
        }
      }

      .point {
        display: inline-block;
        width: 3px;
        height: 3px;
        background-color: #666666;
        margin-left: -10px;
        margin-bottom: 4.9px;
      }
    }
  }
}
</style>
